module.exports = __webpack_public_path__ + "static/media/chat-filled.72e8d7a4.svg";